/*=====================
 Add color class to links
======================*/
window.addEventListener('load', function () {

  function processLinks() {

    const links = document.querySelectorAll('a');

    const wrWords = ['white rabbit', 'vive', 'slim', 'serene'];
    const pepWords = ['peptide', 'joint', 'muscle', 'vascular', 'vision', 'immune', 'brain', 'multivitamin'];
    const silverWords = ['colloidal', 'silver', 'coated'];

    links.forEach(link => {
      if (link.closest('.bsh-cards')) { return; } 
      const text = link.textContent.toLowerCase();

      if (wrWords.some(word => text.includes(word))) {
        link.classList.add('wr-style');
      }

      if (pepWords.some(word => text.includes(word))) {
        link.classList.add('pep-style');
      }

      if (silverWords.some(word => text.includes(word))) {
        link.classList.add('silver-style');
      }
    });

  }

  function handleFirstMove() {
    processLinks();
    document.removeEventListener('mousemove', handleFirstMove);
  }

  document.addEventListener('mousemove', handleFirstMove, { once: true });

});


/*=====================
 Chat widget opener — BestChat / "smartbot" Shopify app embed

 The widget is injected by Shopify via content_for_header, renders
 asynchronously, and its launcher sits inside an open shadow root on
 #smart-bot-container. None of it is theme code, so every lookup is defensive
 and every failure ends at a real URL instead of a dead link.

 Markup:  <a href="/pages/contact-us" data-pb-open-chat>Chat with us</a>
 Console: window.PBOpenChat.state()   // diagnostics
======================*/
(function () {
  const LOG = '[PBOpenChat] ';
  const DEFAULT_FALLBACK = '/pages/contact-us';
  const POLL_MS = 150;
  const WAIT_MS = 4000;
  const COOLDOWN_MS = 1500;

  // Build-hashed classes (_chat-icon-container_tt440_1) change on app updates,
  // so they are only ever matched on their un-hashed prefix.
  const TRIGGERS = [
    '[aria-haspopup="dialog"][role="button"]',
    '[aria-label="Open chat window"]',
    '[class*="chat-icon-container"]',
    '#smart-bot-app-root [role="button"]'
  ];
  const PANELS = ['#smart-bot-chat-box-container', '[class*="chat-box-container"]', '[role="dialog"]'];

  let host = null;
  let firedAt = 0;
  let waiting = false;

  function findHost() {
    if (host && document.contains(host)) return host;
    host = document.querySelector('#smart-bot-container') || document.querySelector('.smart-bot-container');
    return host;
  }

  /* Every query is scoped to the widget host, never to `document`: this theme
     uses [role="dialog"] and [aria-haspopup="dialog"] for its own quick-view and
     cart drawer, and a document-wide lookup would read "chat already open"
     whenever one of those is open — silently killing the link. */
  function roots() {
    const h = findHost();
    if (!h) return [];
    return h.shadowRoot ? [h.shadowRoot, h] : [h];
  }

  function isLauncher(el) {
    const label = (el.getAttribute('aria-label') || '').toLowerCase();
    if (label.indexOf('close') !== -1) return false;
    // closest() stops at the shadow boundary, so this cannot reach theme markup
    return !(el.closest && el.closest('[id*="chat-box"],[class*="chat-box"],[role="dialog"]'));
  }

  function findTrigger() {
    const rs = roots();
    for (const root of rs) {
      for (const sel of TRIGGERS) {
        let list;
        try { list = root.querySelectorAll(sel); } catch (e) { continue; }
        for (const el of list) { if (isLauncher(el)) return el; }
      }
    }
    return null;
  }

  /* offsetParent catches display:none on the node or any ancestor (the panel
     container hides the inner dialog); getClientRects covers position:fixed,
     where offsetParent is always null. */
  function visible(el) {
    if (!el) return false;
    return !!(el.offsetParent || (el.getClientRects && el.getClientRects().length));
  }

  function readState() {
    const rs = roots();
    let trigger = null;
    let panel = null;
    for (const root of rs) {
      if (!trigger) trigger = findTrigger();
      if (!panel) { for (const sel of PANELS) { panel = panel || root.querySelector(sel); } }
    }
    const expanded = trigger ? trigger.getAttribute('aria-expanded') : null;
    return {
      trigger: trigger,
      panel: panel,
      expanded: expanded,
      // Any signal saying "open" wins: firing again would CLOSE a panel the
      // shopper may be typing in, which is worse than the link doing nothing.
      open: visible(panel) || expanded === 'true'
    };
  }

  function snapshot() {
    const h = findHost();
    const st = h ? readState() : null;
    const buttons = [];
    for (const root of roots()) {
      let list;
      try { list = root.querySelectorAll('[role="button"],button'); } catch (e) { continue; }
      for (const el of list) {
        buttons.push({ label: el.getAttribute('aria-label'), cls: String(el.className || '') });
      }
    }
    return {
      hostFound: !!h,
      shadowRoot: h ? (h.shadowRoot ? 'open' : 'null (closed mode?)') : 'n/a',
      triggerFound: !!(st && st.trigger),
      panelFound: !!(st && st.panel),
      ariaExpanded: st ? st.expanded : null,
      treatedAsOpen: !!(st && st.open),
      buttonsVisibleToScript: buttons
    };
  }

  function fallbackTo(url, reason) {
    console.warn(LOG + 'could not open the chat (' + reason + '). Going to ' + url, snapshot());
    if (url) window.location.href = url;
  }

  function act(url) {
    const st = readState();
    if (st.open) return;                              // already open — never toggle shut
    if (Date.now() - firedAt < COOLDOWN_MS) return;   // our previous click is still landing

    if (!st.trigger) {
      console.warn(
        LOG + 'launcher not found. shadowRoot=' +
        (findHost() && findHost().shadowRoot ? 'open' : 'NULL (closed mode?)') +
        '. Selectors tried: ' + TRIGGERS.join(' | ')
      );
      fallbackTo(url, 'launcher not found');
      return;
    }

    firedAt = Date.now();
    st.trigger.click();
  }

  function openChat(fallbackUrl) {
    const url = fallbackUrl || DEFAULT_FALLBACK;
    if (findHost()) { act(url); return; }
    if (waiting) return;                              // one waiter at a time

    // The app embed loads asynchronously, so a click can land before it exists.
    waiting = true;
    const until = Date.now() + WAIT_MS;
    const timer = setInterval(function () {
      if (findHost()) {
        clearInterval(timer);
        waiting = false;
        act(url);
      } else if (Date.now() >= until) {
        clearInterval(timer);
        waiting = false;
        fallbackTo(url, 'widget absent after ' + WAIT_MS + 'ms');
      }
    }, POLL_MS);
  }

  function fallbackFor(el) {
    const attr = el.getAttribute('data-pb-chat-fallback');
    if (attr) return attr;
    const href = el.getAttribute('href') || '';
    if (href && href.charAt(0) !== '#' && href.indexOf('javascript:') !== 0) return href;
    return DEFAULT_FALLBACK;
  }

  window.PBOpenChat = openChat;
  window.PBOpenChat.state = snapshot;

  // Capture phase, so a section handler calling stopPropagation() cannot
  // swallow the link.
  document.addEventListener('click', function (e) {
    const el = e.target.closest ? e.target.closest('[data-pb-open-chat]') : null;
    if (!el) return;
    e.preventDefault();
    openChat(fallbackFor(el));
  }, true);
}());
